import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentMosaicWidgetRendering on MosaicWidgetRendering {
    alias
    id
    payload
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicWidgetRenderingFragment,
  Omit<ents.core.mosaic.Widget.Rendering, 'variables'>
>({
  // NOTE: Eslint disable turned on because of eslint error for payload argument
  // that is type of any
  /* eslint-disable @typescript-eslint/no-unsafe-argument */
  alias: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.common.Aliased.isAliased,
    { warnOnly: true },
  ),
  content: ({ payload }) => JSON.parse(payload)?.content,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.mosaic.Widget.Id.assertIsId,
    { warnOnly: true },
  ),
  name: ({ payload }) => JSON.parse(payload)?.name,
  onClick: ({ payload }) => JSON.parse(payload)?.onClick,
  overflowActions: ({ payload }) => JSON.parse(payload)?.overflowActions,
  type: ({ payload }) => JSON.parse(payload)?.type,
  watch: ({ payload }) => JSON.parse(payload)?.watch,
  /* eslint-enable @typescript-eslint/no-unsafe-argument */
})
